'use strict';

const ONE_HOUR_IN_SECONDS = 60 * 60;
const RESPONSE_TIME_THRESHOLDS = {
  GREEN_THRESHOLD_SECONDS: ONE_HOUR_IN_SECONDS * 1,
  MAX_THRESHOLD_SECONDS: ONE_HOUR_IN_SECONDS * 2,
};

const COUNTER_FORMAT = 'H:mm:ss';
const TIME_FORMAT = 'hh:mm a';
const DATE_FORMAT = 'MMM DD';

angular
  .module('ClinicApp')
  .factory('appointmentRequestTimerStates', function() {
    const getFormattedTimeDifference = (differenceInSeconds) => moment().utc()
      .startOf('year')
      .add(differenceInSeconds, 'seconds')
      .format(COUNTER_FORMAT);

    return [{
      filter: ({ requestGroupName }) => requestGroupName === 'reply',
      title: () => null,
      subtitle: ({ isFromToday }) => `You Replied ${isFromToday ? 'at' : 'on'}`,
      cancelRefresh: true,
      iconClass: null,
      icon: 'arrow-uturn-left',
      warningIcon: null,
    }, {
      filter: ({ differenceInSeconds }) => differenceInSeconds >= RESPONSE_TIME_THRESHOLDS.MAX_THRESHOLD_SECONDS,
      title: () => '2+hours',
      subtitle: ({ requestGroupName }) => 'Since ' + requestGroupName,
      cancelRefresh: true,
      iconClass: 'red',
      icon: 'clock',
      warningIcon: 'exclaimation-circle',
    }, {
      filter: ({ differenceInSeconds }) => differenceInSeconds >= RESPONSE_TIME_THRESHOLDS.GREEN_THRESHOLD_SECONDS,
      title: ({ differenceInSeconds }) => getFormattedTimeDifference(differenceInSeconds),
      subtitle: ({ requestGroupName }) => 'Since ' + requestGroupName,
      cancelRefresh: false,
      iconClass: 'yellow',
      icon: 'clock',
      warningIcon: null,
    }, {
      filter: () => true,
      title: ({ differenceInSeconds }) => getFormattedTimeDifference(differenceInSeconds),
      subtitle: ({ requestGroupName }) => 'Since ' + requestGroupName,
      cancelRefresh: false,
      iconClass: 'green',
      icon: 'clock',
      warningIcon: null,
    }];
  });

angular.module('ClinicApp').directive('appointmentRequestTimer', function($interval, appointmentRequestTimerStates, appointmentOrganizerRequestGroups, OCAppointmentUtil) {
  return {
    templateUrl: '/views/directives/_appointment-request-timer.html',
    scope: {
      appointment: '=',
    },
    link: function($scope) {
      let refreshTimer;

      function appointmentReloaded() {
        $scope.requestGroup = _.find(appointmentOrganizerRequestGroups, {
          name: $scope.appointment.requestGroup,
        });
      }

      function isToday(date) {
        const startOfDay = moment().startOf('day');
        return startOfDay.isBefore(date);
      }

      function formatDate(date) {
        const useTimeFormat = isToday(date);
        const format = useTimeFormat ? TIME_FORMAT : DATE_FORMAT;
        return date.format(format);
      }

      $scope.$watch('appointment', appointmentReloaded);
      appointmentReloaded();

      $scope.getIconUrl = (icon) => {
        if (!icon) {
          return null;
        }

        return `/img/icons/${icon}.svg`;
      };

      function refresh() {
        const requestedAt = moment($scope.appointment.createdAt);
        const lastAction = OCAppointmentUtil.getLastNotifiableHistoryItem($scope.appointment);
        const lastActionDate = lastAction ? moment(lastAction.createdAt) : requestedAt;

        const isLastActionFromToday = isToday(lastActionDate);
        $scope.lastActionString = formatDate(lastActionDate);
        $scope.requestedAtString = formatDate(requestedAt);

        const requestGroupName = $scope.requestGroup.name;
        const differenceInSeconds = moment().utc()
          .diff(lastActionDate, 'seconds');

        const state = appointmentRequestTimerStates.find((option) =>
          option.filter({
            differenceInSeconds,
            requestGroupName,
          }));

        $scope.sinceRequestString = state.title({ differenceInSeconds });
        $scope.sinceRequestStringSubtext = state.subtitle({
          requestGroupName,
          isFromToday: isLastActionFromToday,
        });
        $scope.iconClass = state.iconClass;

        $scope.icon = state.icon;
        $scope.warningIcon = state.warningIcon;

        if (state.cancelRefresh) {
          $interval.cancel(refreshTimer);
        }
      }

      refresh();
      refreshTimer = $interval(refresh, 1000);
    },
  };
});
